import { render, staticRenderFns } from "./singleUpload.vue?vue&type=template&id=0d8a138a"
import script from "./singleUpload.vue?vue&type=script&lang=js"
export * from "./singleUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports